import { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;
// Fallback = current published values, used until the admin-managed settings load.
export const CONTACT_FALLBACK = {
  phone: '9234354174', phone_href: 'tel:+919234354174', whatsapp_enabled: true, whatsapp_number: '9234354174',
  whatsapp_message: 'Hi EvalentX team, I have a question.',
  whatsapp_link: 'https://wa.me/919234354174?text=Hi%20EvalentX%20team%2C%20I%20have%20a%20question.',
  whatsapp_channel_url: 'https://whatsapp.com/channel/0029Vb7bm406hENlVvaN9x3R',
};

let cache = null;
let inflight = null;
const load = () => {
  if (!inflight) inflight = axios.get(`${API}/api/public/site-contact`).then((r) => { cache = r.data; return cache; }).catch(() => { inflight = null; return CONTACT_FALLBACK; });
  return inflight;
};

export const useSiteContact = () => {
  const [c, setC] = useState(cache || CONTACT_FALLBACK);
  useEffect(() => { let on = true; load().then((d) => on && setC(d)); return () => { on = false; }; }, []);
  return c;
};
